import React, { useRef } from "react";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";

const KS10IRDNumber = (props) => {
  const { IRD, setIRDData, keyName, serialNumber, title, message } = props;
  const irdNumberRef = useRef(null);
  const onIRDChange = e => {
    checkChildrenAndSetFocus(irdNumberRef.current.children, e.target.name.replace(keyName, ""));
    setIRDData({ "name":e.target.name, "value":e.target.value});
  }
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
        <div className="mb-3 number">{serialNumber}.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label ">
              <label className="">{title}</label>
            </div>
            <div className="pr-3" ref={irdNumberRef} >
            {[...Array(9).keys()].map((i) => (
                <input maxLength="1" type="text" key={`${keyName}${i + 1}`} id={`${keyName}${i + 1}`} name={`${keyName}${i + 1}`} 
                className="form-control text-center" value={IRD[i]} onChange={onIRDChange} style={i==2 || i==5 ? {  marginRight: "10px"} :{}} />
            ))}
            </div>
            <small className="label-line-height top-space">{message}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10IRDNumber;
